import { CryptoJS } from '~/modules';

export const uploadFileToAzure = async (file: {
  blob: Blob;
  name: string;
  type: string;
}) => {
  const {
    REACT_APP_AZURE_STORAGE_PATH,
    REACT_APP_AZURE_ACCOUNT_NAME,
    REACT_APP_AZURE_ACCOUNT_KEY,
    REACT_APP_AZURE_CONTAINER_NAME,
  } = process.env;

  try {
    const blobName =
      file.name ||
      `file_${Date.now()}_${Math.random().toString(36).substring(2, 10)}.jpg`;
    const uploadUrl = `${REACT_APP_AZURE_STORAGE_PATH}/${blobName}`;

    const fileBlob: Blob = file.blob || file;

    if (!fileBlob.size) {
      throw new Error('Tamanho do arquivo inválido');
    }

    const date = new Date().toUTCString();
    const contentType = file.type || 'image/jpeg';
    const contentLength = fileBlob.size.toString();

    const blobUri = `/${REACT_APP_AZURE_ACCOUNT_NAME}/${REACT_APP_AZURE_CONTAINER_NAME}/${blobName}`;

    const authHeader = generateAuthorizationHeader(
      REACT_APP_AZURE_ACCOUNT_NAME,
      REACT_APP_AZURE_ACCOUNT_KEY,
      'PUT',
      contentLength,
      contentType,
      date,
      blobUri,
    );

    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType,
        'Content-Length': contentLength,
        'x-ms-blob-type': 'BlockBlob',
        'x-ms-date': date,
        'x-ms-version': '2020-04-08',
        Authorization: authHeader,
      },
      body: fileBlob,
    });

    if (response.status !== 201) {
      throw new Error('Erro no upload do arquivo');
    }

    return uploadUrl;
  } catch (error) {
    throw new Error('Erro no upload do arquivo');
  }
};

const generateAuthorizationHeader = (
  accountName,
  accountKey,
  method,
  contentLength,
  contentType,
  date,
  blobUri,
) => {
  const stringToSign = [
    method,
    '', // Content-Encoding
    '', // Content-Language
    contentLength, // Content-Length
    '', // Content-MD5
    contentType, // Content-Type
    '', // Date
    '', // If-Modified-Since
    '', // If-Match
    '', // If-None-Match
    '', // If-Unmodified-Since
    '', // Range
    `x-ms-blob-type:BlockBlob`,
    `x-ms-date:${date}`,
    `x-ms-version:2020-04-08`,
    blobUri, // /{accountName}/{containerName}/{blobName}
  ].join('\n');

  const signature = CryptoJS.HmacSHA256(
    stringToSign,
    CryptoJS.enc.Base64.parse(accountKey),
  ).toString(CryptoJS.enc.Base64);

  return `SharedKey ${accountName}:${signature}`;
};
